import React from 'react';
import PropTypes from 'prop-types';

import '../ChecklistV2.less';
import './ChecklistCompleteTaskButton.less';

const ChecklistCompleteTaskButton = ({ onClick, taskCompleted, taskId }) => (
  <button
    onClick={() => onClick(taskId)}
    className="checklist__button checklist__button--completeTask checklist__button--large"
  >
    <i className="zola-ui-icon zola-ui-icon-checkmark checklist__completeTask--icon" />
    {taskCompleted ? 'Completed' : 'Check It Off'}
  </button>
);

ChecklistCompleteTaskButton.propTypes = {
  onClick: PropTypes.func,
  taskCompleted: PropTypes.bool,
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ChecklistCompleteTaskButton.defaultProps = {
  taskCompleted: false,
};

export default ChecklistCompleteTaskButton;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistCompleteTaskButton/ChecklistCompleteTaskButton.jsx